import { PLATFORM, PLATFORMS } from '@/domains/core/settings/constants';

// Maybe you want to use conditional build?
// This file may be deprecated in favor of conditional build
/**
 * @deprecated use @/domains/core/settings/utils instead
 */
const isUkPlatform = () => PLATFORM === PLATFORMS.GREAT_BRITAIN;
/**
 * @deprecated use @/domains/core/settings/utils instead
 */
const isItalyPlatform = () => PLATFORM === PLATFORMS.ITALY;
/**
 * @deprecated use @/domains/core/settings/utils instead
 */
const isFrancePlatform = () => PLATFORM === PLATFORMS.FRANCE; // Maybe you are interested in IS_B2B_MARKET_AVAILABLE_FOR_THIS_PLATFORM?

export { isUkPlatform, isItalyPlatform, isFrancePlatform };
